// extracted by mini-css-extract-plugin
module.exports = {"clientsSectionContainer":"Clients-module--clientsSectionContainer--1xV8B","clientsContainer":"Clients-module--clientsContainer--3dTPb","client":"Clients-module--client--33hiq"};